import React, { FC, useCallback, useEffect, useState } from 'react';
import styles from './_styles.module.scss';
import { IReviewCandidate } from '../../core/models/models';
import noPhoto from '../../assets/images/no_photo_candidate.png';
import UIReviewCandidateQuality from '../UI/UIReviewCandidateQuality/UIReviewCandidateQuality';
import ContactInfo from './ContactInfo';
import { useAppSelector } from '../../core/hooks/reduxHooks';
import useWebContent from "../../core/hooks/useWebContent";

const { REACT_APP_BASE_API_URL } = process.env;

const CandidateRating = ({ rating, tutor_id }: { rating: number | null; tutor_id: string }) => {
  const [webContent] = useWebContent();
  const ratingText = !rating
    ? 'No rating available'
    : `${rating} ${webContent.out_of_5}`;

  return (
    <div className={styles.candidate_rating}>
      <strong>{webContent.rating_on_candidate} </strong>
      <a href={`/candidate/rating/${tutor_id}`}>{ratingText}</a>
    </div>
  );
};

const ReviewCandidateDetails: FC<{
  assignmentId: string;
  details: IReviewCandidate;
  role: 'employer' | 'admin';
  index: number;
}> = ({ assignmentId, details, index, role }) => {
  const [isFallbackImage, setIsFallbackImage] = useState(false);
  const { jobDetails } = useAppSelector(state => state.UserManageJobsReducer);
  const [webContent] = useWebContent();
  const imageUrl = '' + REACT_APP_BASE_API_URL + '/api/v1/front' + details.profile_picture_fs;

  const handleError = () => {
    setIsFallbackImage(true);
  };

  return (
    <li
      className={`${styles.review}  ${
        details.shortlisted
          ? styles.review_shortlisted
          : styles.review_not_shortlisted
      }`}
    >
      <div className={styles.review_header}>
        <h4 className={styles.review_index}>Candidate {index}</h4>
        <div className={styles.photo_wrap}>
          <img
            src={isFallbackImage ? noPhoto : imageUrl}
            alt='Candidate photo'
            className={styles.photo}
            onError={handleError}
          />
        </div>
      </div>

      <div className={styles.review_qualities}>
        <CandidateRating rating={details.avg_rating} tutor_id={details.tutor_id} />
        {details.age !== null && (
          <UIReviewCandidateQuality title={webContent.age_web} quality={details.age} />
        )}
        {details.gender !== null && (
          <UIReviewCandidateQuality title={webContent.gender_web} quality={details.gender} />
        )}
        {details.race !== null && (
          <UIReviewCandidateQuality title={webContent.race_web} quality={details.race} />
        )}
        {details.years_teaching !== null && (
          <UIReviewCandidateQuality
            title={'Years of experience'}
            quality={details.years_teaching}
          />
        )}
        {details.citizenship !== null && (
          <UIReviewCandidateQuality
            title={webContent.nationality_web}
            quality={details.citizenship}
          />
        )}
        {details.group !== null && (
          <UIReviewCandidateQuality title={webContent.group_web} quality={details.group} />
        )}
        {details.qualification !== null && (
          <UIReviewCandidateQuality
            title={webContent.highest_qualification_web}
            quality={details.qualification}
          />
        )}
        <UIReviewCandidateQuality
          title={webContent.available_day_and_time_web}
          quality={details.day_and_time}
        />
        <UIReviewCandidateQuality
          title={webContent.expected_salary_web}
          quality={details.expected_salary}
        />
      </div>
      <div className={styles.contact_wrap}>
        <div className={styles.wrap}>
          <p className={styles.applied}>Applied on {details.applied_on}</p>
          {/*<p className={styles.shortlisted}>*/}
          {/*  {details.shortlisted ? 'Shortlisted' : 'Not shortlisted'}*/}
          {/*</p>*/}
        </div>
        <ContactInfo
          assignmentId={assignmentId}
          proposal_id={details.id}
          shortlistValue={
            role === 'employer' && jobDetails ? jobDetails.shortlists_left : 1
          }
          role={role}
        />
      </div>
      <UIReviewCandidateQuality
        title={webContent.details_of_experience_web}
        experience={details.experience}
      />
    </li>
  );
};

export default ReviewCandidateDetails;
